// @need-translate
import ClipboardJS from 'clipboard';
import {getEnv} from '../common/env/env';
import {t} from '../common/getTranslations';
import {openWindow} from '../common/openWindow.function';
import {requestContext} from '../common/requestContext';
import {importKakaoSdk} from '../common/shared/login-pageweb/importKakaoSdk.function';
import {importSandboxKakaoSdk} from '../common/shared/login-pageweb/importSandboxKakaoSdk.function';
import {showToast} from '../toast/toastHandler';
import {ShareType} from './constants';
import {getKakaotalkTemplateId} from './getKakaotalkTemplateId';
import {ShareProps} from './shareProps.interface';

export function share({
  url,
  shareType,
  title,
  message,
  scheme,
  templateId,
  btnLabel,
}: ShareProps) {
  // 인앱 웹뷰인 경우에는 share 스킴을 생성한 후 실행합니다.
  if (window.KPApp) {
    let scheme = `kakaopage://share?url=${encodeURIComponent(
      encodeURIComponent(url)
    )}&type=${shareType}`;

    if (message) {
      scheme += `&message=${encodeURIComponent(message)}`;
    }
    if (scheme) {
      scheme += `&scheme=${encodeURIComponent(scheme)}`;
    }
    if (btnLabel) {
      scheme += `&btn_label=${encodeURIComponent(btnLabel)}`;
    }
    if (templateId) {
      scheme += `&template_id=${templateId}`;
    }

    if (window.top) {
      window.top.location.href = scheme;
    } else {
      window.location.href = scheme;
    }
    return;
  }

  shareAction[shareType]({
    url,
    title,
    scheme,
    message,
    templateId,
    btnLabel,
  });
}

export function shareToKakaoTalk({
  url,
  title,
  scheme,
  templateId: _templateId,
  message,
  btnLabel,
}: {
  url: string;
  title: string;
  scheme: string;
  templateId?: number;
  message?: string;
  btnLabel?: string;
}) {
  const templateId = getKakaotalkTemplateId({
    templateId: _templateId,
    url,
  });

  // PC웹 및 모웹인 경우에는 각 케이스 별로 공유하기 처리를 합니다.
  const importKakaoSdkFunc = getEnv().useSandboxKakao
    ? importSandboxKakaoSdk
    : importKakaoSdk;

  importKakaoSdkFunc().then(() => {
    window.Kakao.Share.sendScrap({
      requestUrl: url,
      templateId,
      templateArgs: {
        Weblink: url,
        TITLE: title,
        DESCRIPTION: message,
        ButtonLabel: btnLabel ?? t('common_tab_direct'),
        ...(scheme && {
          AndroidExecParam: scheme,
          iOSExecParam: scheme,
        }),
      },
      installTalk: true,
    });
  });
}

export function shareToFacebook({url}: {url: string}) {
  const encodedUrl = `https://facebook.com/sharer.php?u=${encodeURIComponent(
    url
  )}`;
  openWindow({
    url: encodedUrl,
    target: '페이스북 공유',
    features: 'left=0,top=0,width=500,height=500',
  });
}

export function shareOsDefault({url, title}: {url: string; title: string}) {
  if (window?.navigator.share) {
    try {
      window.navigator.share({
        url,
        title,
      });
    } catch {
      // 사용자가 공유를 취소하면 에러를 발생시킵니다. 에러를 만들지 않기 위해 catch를 사용합니다.
      showToast({
        message: '공유하기가 취소되었습니다.',
        isMobile: requestContext.requestInfo.display.isMobile,
        delayMs: 2000,
      });
    }
  } else {
    showToast({
      message: '현재 환경에서 해당 공유하기를 지원하지 않습니다.',
      isMobile: requestContext.requestInfo.display.isMobile,
      delayMs: 2000,
    });
  }
}

export function shareToTwitter({url, title}: {url: string; title: string}) {
  const encodedUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url
  )}&text=${title}`;
  openWindow({
    url: encodedUrl,
    target: '트위터 공유',
    features: 'left=0,top=0,width=500,height=500',
  });
}

export function shareUrl({url}: {url: string}) {
  if (!ClipboardJS.isSupported()) {
    showToast({
      message: '링크를 복사할 수 없습니다.',
      isMobile: requestContext.requestInfo.display.isMobile,
      delayMs: 2000,
    });
  } else {
    ClipboardJS.copy(url);
    showToast({
      message: '공유링크를 복사했습니다.',
      isMobile: requestContext.requestInfo.display.isMobile,
      delayMs: 2000,
    });
  }
}

export const shareAction: {[key in ShareType]: any} = {
  [ShareType.KakaoTalk]: shareToKakaoTalk,
  [ShareType.Facebook]: shareToFacebook,
  [ShareType.More]: shareOsDefault,
  [ShareType.Url]: shareUrl,
  [ShareType.Twitter]: shareToTwitter,
};
